module.exports = __webpack_public_path__ + "img/social-vk.2692adc0.svg";